module.exports = __webpack_public_path__ + "img/AdvanceLogo.b73bba66.svg";